import Api from '../utils/Api';
import Config from '../config/Config';

class CreditoService {
  constructor() {
    this.url = Config.URL_SERVICE;
    this.api = new Api({ url: this.url });
    this.api.createEntities([{ name: 'credito' }, { name: 'documento' }]);
  }

  realizarSimulacion(data, trackId) {
    const config = { headers: { 'trackId': trackId } };
    return this.api.endpoints.credito
      .createWithAction('simular', data, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  solicitarCredito(enfermedades, trackId) {
    const config = { headers: { 'trackId': trackId } };
    const bodyParam = {
      "params": {
        "enfermedadesSeleccionadas": enfermedades
      }
    }
    return this.api.endpoints.credito
      .createWithAction('solicitar', bodyParam, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  simular(montoSolicitado, rentaBrutaMensual, cuotas, idSegurosSeleccionados, trackId) {
    const bodyParam = {
      "params": {
        "montoSolicitado": montoSolicitado,
        "cuotas": cuotas,
        "rentaBrutaMensual": rentaBrutaMensual,
        "idSegurosSeleccionados":idSegurosSeleccionados
      }
    }
    const config = { headers: { 'trackId': trackId } };
    return this.api.endpoints.credito
      .createWithAction('simular', bodyParam, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  realizarFormalizacion(trackId) {
    const config = { headers: { 'trackId': trackId } };
    return this.api.endpoints.credito
      .getWithAction('formalizar',config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  cursarCredito(emailAlternativo, enviarCorreoAlternativo, enviarCorreoIbs, trackId) {
    const bodyRequest = {
      params: {
        emailAlternativo,
        enviarCorreoAlternativo, 
        enviarCorreoIbs
      }
    };
    const config = { headers: { 'trackId': trackId } };
    return this.api.endpoints.credito
      .createWithAction('cursar', bodyRequest, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  crearDocumento(estado, tipo, trackId) {
    const config = { headers: { trackId } };
    return this.api.endpoints.documento
      .getWithParams('obtener',`estado=${estado}&tipo=${tipo}`, config)
      .then(response => { return response.data })
      .catch(error => { throw error });
  }

  mostrarCredito() {
    return this.api.endpoints.credito
      .getWithParams(`muestra`,`consultar=false`)
      .then(response => { return response.data })
      .catch(error => { throw error });
  }



}

export default new CreditoService;